import { Component, OnInit } from '@angular/core';
import { ApiService } from '../services/api.service';
import { AppComponent } from '../app.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { PermissionsService } from '../services/permissions.service';
import { ConfirmationPopoverComponent } from '../confirmation-popover/confirmation-popover.component';

@Component({
  selector: 'app-department-limit',
  templateUrl: './department-limit.component.html',
  styleUrls: ['./department-limit.component.scss']
})
export class DepartmentLimitComponent implements OnInit {
  public itemCategories: any;
  public perPage = 20;
  public totalCount = 0;
  public page = 1;

  constructor(
    private apiService: ApiService,
    private appComponet: AppComponent,
    private modalService: NgbModal,
    public permissionsService: PermissionsService,
    private appComponent: AppComponent, 
    ) { }

  ngOnInit() {
    this.getList('');
  }

  getList(_type) {
    this.appComponet.showLoader();
    this.apiService.getDataFromServer(`/department_limit/increasable`).subscribe(
      (res: any) => {
        this.appComponet.hideLoader();
        this.itemCategories = res;
        this.totalCount = res.data.length;
      },
      err => {
        console.log(err);
      }
    );
  }


}